import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import creditapps from './modules/creditapps';
import quickQualify from './modules/quick-qualify';
import client from './modules/client';
import lead from './modules/lead';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
      auth,
      creditapps,
      quickQualify,
      client,
      lead,
    },
    strict: process.env.NODE_ENV !== 'production',
});
